export default "__VITE_ASSET__BHwNhWOK__"